import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, Validators, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NavigationService } from "src/app/services/navigation.service";
import { AlertService } from "src/app/services/alert.service";
import { BookingService } from "src/app/services/booking.service";
import { FarmerService } from "src/app/services/farmer.service";
import { Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { EventType } from "src/enum/eventtype";
import * as moment from "moment";
import { DepartmentType } from "src/enum/departmenttype";

@Component({
  selector: "app-aeefarmerpopup",
  templateUrl: "./aeefarmerpopup.component.html",
  styleUrls: ["./aeefarmerpopup.component.scss"],
})
export class AeefarmerpopupComponent implements OnInit {
  // Mandatory above 1 lakh, except Tractor (1) and Combine Harvester (3)
  get isLaserCutRequired(): boolean {
    const cat = this.dataRecievedData?.session?.machinaryCategoryType;
    return this.dataRecievedData?.session?.totalCost > 100000 && cat != 1 && cat != 3;
  }

  showNotes: boolean = true;
  form: FormGroup;
  id: any;
  gstFileName: any;
  gstfiles: any;
  panfiles: any;
  panFileName: any;
  imagePath: any;
  fileType: number;
  filesResult: any;
  dealerData: any[] = [];
  inspectionAttachmentData: any = [];
  inspectionAccesstype: boolean = false;
  inspectionFilesResult: any;
  inspectionAcceptsize: number = 0;
  inspectionFileType: any;
  inspectionSelectedFileName: any;
  indeterminate: { key: number; value: string }[];
  attachmentsDataSource = new MatTableDataSource([]);
  images: any[];
  selectedFileName: any;
  attachmentlen: any[] = [];
  gstList: any[] = [];
  gstListCopy: any[] = [];
  attachmentData: any[] = [];
  sort: any;
  paginator: any;
  productImageFileName: any;
  productImagefiles: any;
  private _lightbox: any;
  public eventEnum = EventType;
  verificationList: any = [];
  event: any;
  verificationFormArray: any[] = [];
  today: Date;
  deliveryts: any;
  bookedTs: any;
  maxDate: Date;
  minDate: Date;
  isDisabled: boolean = false;
  MachineryphotoName: any;
  ChassisName: any;
  EngineImageName: string;
  filterlist1: any;
  verifyList: any = [];
  VerificationList: any[] = [];
  physicalVerification: any = [];
  loading: boolean = false;
  physicalVerifyName: any;
  laserCutName: any;
  deptEnum = DepartmentType;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private farmerService: FarmerService,
    private router: Router,
    public dialogRef: MatDialogRef<AeefarmerpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    private bookingService: BookingService,
    public addServiceDialog: MatDialog,
    private navigationService: NavigationService
  ) {
    (this.id = this.dataRecievedData.id),
      (this.deliveryts = this.dataRecievedData.deliveryTs),
      (this.bookedTs = this.dataRecievedData.bookedTs);
  }

  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
    this.today = new Date();
    this.maxDate = new Date();
    this.minDate = new Date(moment(this.bookedTs).format("YYYY, MM, DD"));
    this.farmerService.getVerification(true).subscribe((res) => {
      this.verificationList = res;
      if (this.dataRecievedData.session.eventType != this.eventEnum.AdminAEPhysicalVerifiedSendback) {
        this.verificationList.forEach((element) => {
          let getFiltereddata =
            this.dataRecievedData.session.verificationList.filter(
              (x) => x.key == element.key
            );
          if (getFiltereddata && getFiltereddata.length > 0) {
            element.checked = true;
          } else {
            element.checked = false;
          }
        });
      }
    });

    if (this.dataRecievedData.session.eventType == this.eventEnum.AEESendBack || this.dataRecievedData.session.eventType == this.eventEnum.ManufacturerSendBackUpdate) {
      this.selectedFileName = this.dataRecievedData.session.machinaryImagePath;
      this.ChassisName = this.dataRecievedData.session.chassisImagePath;
      this.EngineImageName = this.dataRecievedData.session.engineImagePath;
      this.physicalVerifyName = this.dataRecievedData.session.physicalVerificationImagePath
      this.laserCutName = this.dataRecievedData.session.physicalVerificationlaserCutImagePath
      this.form.controls["paymentTs"].setValue(
        this.dataRecievedData.session.dateofTransfer
      );
      this.form.controls["physicalVerificationTs"].setValue(
        this.dataRecievedData.session.physicalVerificationTs
      );
      this.form.controls["productImage_file"].setValue(
        this.dataRecievedData.session.machinaryImagePath
      );
      this.form.controls["EngineImage"].setValue(
        this.dataRecievedData.session.engineImagePath
      );
      this.form.controls["Chassisno"].setValue(
        this.dataRecievedData.session.chassisImagePath
      );
      this.form.controls["physicalVerifyReport"].setValue(
        this.dataRecievedData.session.physicalVerificationImagePath
      );
      this.form.controls["laserCutImage"].setValue(
        this.dataRecievedData.session.physicalVerificationlaserCutImagePath
      );
      this.form.controls["remarks"].setValue(
        this.dataRecievedData.session.remarks
      );
    }
  }

  initializeValidators() {
    const physicalVerificationRequired =
      !this.dataRecievedData?.session?.physicalVerificationImagePath;
    this.form = this.formBuilder.group({
      paymentTs: [null, Validators.required],
      physicalVerificationTs: [
        null,
        physicalVerificationRequired ? Validators.required : null,
      ],
      verification: [null],
      remarks: [null, Validators.required],
      productImage_file: [null, Validators.required],
      EngineImage: [null],
      Chassisno: [null, Validators.required],
      physicalVerifyReport: [
        null,
        physicalVerificationRequired ? Validators.required : null,
      ],
      laserCutImage: [null],
      laserCutNumber: [null],
      latitude: [null, Validators.required],
      longitude: [null, Validators.required],

    });
  }

  next() {
    this.dialogRef.close();
    this.router.navigate(["/aefarmerbookingview"]);
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  ongstFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (
      file.type === "application/pdf" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/jpeg"
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.gstFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.gstfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["gst_file"].setValue(this.filesResult);
            this.form.controls["gst_filename"].setValue(file.name);
            this.dealerData.push({
              id: this.dealerData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 32,
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload JPG, JPEG, PNG and PDF only");
    }
  }

  open(data: any, index: number): void {
    let currbase64string = "data:image/jpg;base64," + data.base64String;
    this.images = [];
    const images = this.attachmentData.map((e, index) => {
      if (e.fileType == 1) {
        this.images.push({
          src: "data:image/jpg;base64," + e.base64String,
          // caption: 'image' + (index + 1),
          thumb: "data:image/jpg;base64," + e.base64String,
        });
      }
    });
    let findindex = this.images.findIndex((x) => x.src === currbase64string);
    this._lightbox.open(this.images, findindex, { centerVertically: true });
  }

  onFileSelected(event1) {
    const file = event1.target.files[0];
    let ext = file.name.split(".").pop();
    if (
      file &&
      (file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg")
    ) {
      // if (this.attachmentlen.length < 3) {
      if (ext !== "pdf") {
        this.fileType = 1;
      } else {
        this.fileType = 2;
      }
      this.selectedFileName = file.name;
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize < 2048) {
        if (event1.target.files && event1.target.files[0]) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.filesResult = event.target.result.split(",")[1];
            if (this.filesResult) {
              this.form.controls["productImage_file"].setValue(
                this.filesResult
              );
              this.form.controls["productImage_file"].setValue(
                this.filesResult ? this.selectedFileName : ""
              ); // <-- Set Value for Validation
            }
            this.attachmentlen.push({ id: 0 });

            this.attachmentData.push({
              id: 0,
              attachmentFilename: this.selectedFileName,
              base64String: this.filesResult,
              // attachmentPath: "string",
              attachmentType: 32,
              statusType: 2,
              fileType: this.fileType,
            });
            this.attachmentsDataSource.data = this.attachmentData.filter(
              (e) => e.statusType !== 3
            );
            this.attachmentsDataSource.sort = this.sort;
            this.attachmentsDataSource.paginator = this.paginator;
          };
        }
      } else {
        this.alertService.error(
          "File size is large, Please upload less than 2 MB"
        );
        this.selectedFileName = "";
      }
      // } else {
      //   this.alertService.error('limit exceeded while uploading more than 3 images');
      // }
    } else {
      this.alertService.error("Please upload  JPG & PNG images");
    }
  }
  EngineImageSelected(event1) {
    const file = event1.target.files[0];
    let ext = file.name.split(".").pop();
    if (
      file &&
      (file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg")
    ) {
      // if (this.attachmentlen.length < 3) {
      if (ext !== "pdf") {
        this.fileType = 1;
      } else {
        this.fileType = 2;
      }
      this.EngineImageName = file.name;
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize < 2048) {
        if (event1.target.files && event1.target.files[0]) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.filesResult = event.target.result.split(",")[1];
            if (this.filesResult) {
              this.form.controls["EngineImage"].setValue(this.filesResult);
              this.form.controls["EngineImage"].setValue(
                this.filesResult ? this.EngineImageName : ""
              ); // <-- Set Value for Validation
            }
            this.attachmentlen.push({ id: 0 });

            this.attachmentData.push({
              id: 0,
              attachmentFilename: this.EngineImageName,
              base64String: this.filesResult,
              // attachmentPath: "string",
              attachmentType: 46,
              statusType: 2,
              fileType: this.fileType,
            });
            this.attachmentsDataSource.data = this.attachmentData.filter(
              (e) => e.statusType !== 3
            );
            this.attachmentsDataSource.sort = this.sort;
            this.attachmentsDataSource.paginator = this.paginator;
          };
        }
      } else {
        this.alertService.error(
          "File size is large, Please upload less than 2 MB"
        );
        this.EngineImageName = "";
      }
      // } else {
      //   this.alertService.error('limit exceeded while uploading more than 3 images');
      // }
    } else {
      this.alertService.error("Please upload  JPG & PNG images");
    }
  }
  ChassisnoSelected(event1) {
    const file = event1.target.files[0];
    let ext = file.name.split(".").pop();
    if (
      file &&
      (file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg")
    ) {
      // if (this.attachmentlen.length < 3) {
      if (ext !== "pdf") {
        this.fileType = 1;
      } else {
        this.fileType = 2;
      }
      this.ChassisName = file.name;
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize < 2048) {
        if (event1.target.files && event1.target.files[0]) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.filesResult = event.target.result.split(",")[1];
            if (this.filesResult) {
              this.form.controls["Chassisno"].setValue(this.filesResult);
              this.form.controls["Chassisno"].setValue(
                this.filesResult ? this.ChassisName : ""
              ); // <-- Set Value for Validation
            }
            this.attachmentlen.push({ id: 0 });

            this.attachmentData.push({
              id: 0,
              attachmentFilename: this.ChassisName,
              base64String: this.filesResult,
              // attachmentPath: "string",
              attachmentType: 47,
              statusType: 2,
              fileType: this.fileType,
            });
            this.attachmentsDataSource.data = this.attachmentData.filter(
              (e) => e.statusType !== 3
            );
            this.attachmentsDataSource.sort = this.sort;
            this.attachmentsDataSource.paginator = this.paginator;
          };
        }
      } else {
        this.alertService.error(
          "File size is large, Please upload less than 2 MB"
        );
        this.ChassisName = "";
      }
      // } else {
      //   this.alertService.error('limit exceeded while uploading more than 3 images');
      // }
    } else {
      this.alertService.error("Please upload  JPG & PNG images");
    }
  }
  onChange(email: number, event: any) {
    if (event.checked) {
      this.verificationFormArray.push(email);
    } else {
      let index = this.verificationFormArray.indexOf(email);
      this.verificationFormArray.splice(index, 1);
    }
  }

  OndeleteAttachment(index: number) {
    this.attachmentData = this.attachmentData.filter((item, i) => {
      if (index !== i) return true;
    });
    this.attachmentlen = this.attachmentlen.splice(
      1,
      this.attachmentlen.length
    );
    this.attachmentsDataSource.data = this.attachmentData;
  }

  clear(event) {
    event.target.value = null;
  }

  // selectAllTransfer(event: any) {
  //   this.event = event;
  // }

  onSave(event: any) {
    if (this.dataRecievedData?.session?.manufacturerType == 1) {
      this.form.controls["EngineImage"].setValidators(Validators.required);
      this.form.controls["EngineImage"].updateValueAndValidity();
    } else {
      this.form.controls["EngineImage"].clearValidators();
      this.form.controls["EngineImage"].updateValueAndValidity();
    }

    if (this.isLaserCutRequired) {
      this.form.controls["laserCutImage"].setValidators(Validators.required);
      this.form.controls["laserCutImage"].updateValueAndValidity();
      this.form.controls["laserCutNumber"].setValidators(Validators.required);
      this.form.controls["laserCutNumber"].updateValueAndValidity();
    }
    
    if (this.form.valid) {
      this.isDisabled = true;
      this.loading = true;
      let request = {
        id: this.id,
        acNo: "",
        cityId: null,
        branchId: null,
        ifsc: "",
        dbtSchemeId: null,
        dbtComponentId: null,
        dbtProductId: null,
        dbtProductInfoId: null,
        dbtManufacturerId: null,
        dbtDealerId: null,
        eventType:
          this.dataRecievedData.session.eventType == this.eventEnum.AEESendBack
            ? this.eventEnum.AESendBackUpdate
            : this.eventEnum.AEApproval,
        bankId: 0,
        transactionType: 0,
        paymentTs: null,
        DateofTransfer: moment(this.form.value.paymentTs).format("YYYY-MM-DD"),
        PhysicalVerificationTs: this.form.value.physicalVerificationTs
          ? moment(this.form.value.physicalVerificationTs).format("YYYY-MM-DD")
          : null,
        receiptNumber: "",
        productCost: 0,
        gstPercentage: 0,
        subsidyAmount: 0,
        totalCost: 0,
        engineNumber: "",
        chassisNumber: "",
        registrationNumber: "",
        deliveryTs: null,
        verificationIds: this.verificationFormArray,
        remarks: this.form.value.remarks,
        attachment: this.attachmentData,
        laserCutNumber: this.form.value.laserCutNumber,
        latitude: this.form.value.latitude || 0,
        longitude: this.form.value.longitude || 0
      };
      this.farmerService.farmerSave(request).subscribe((res) => {
        if (res && res.isSuccess) {
          this.alertService.success(
            "Successfully updated the field inspection details."
          );
          this.dialogRef.close();
          this.router.navigate(["/aefarmerbooking"]);
        }
        this.isDisabled = false;
        this.loading = false;
      });
    } else {
      this.validateFormControl();
    }
    // } else {
    //   this.alertService.error("upload 3 images");
    // }
  }
  downloadattachament() {
    this.farmerService.getInspectionReport(this.id, 2, true).subscribe((res) => {
      if (res) {
        const linkSource = "data:application/pdf;base64, " + res;
        const downloadLink = document.createElement("a");
        const fileName = "Physical Verification.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }
  PhysicalVerificationUpload(event) {
    const file = event.target.files[0];
    if (
      file.type === "application/pdf" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/jpeg"
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.physicalVerifyName = file.name;
      let checkType = file.type;
      let getFileType = checkType.split("/");
      if (getFileType[1] == "pdf") {
        this.fileType = 2;
      } else {
        this.fileType = 1;
      }
      if (acceptsize < 2048) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          // this.filesResult = event.target.result;
          this.filesResult = event.target.result.split(",")[1];
          this.form.controls["physicalVerifyReport"].setValue(this.filesResult);
          // this.form.controls['ins_filename'].setValue(file.name);
          this.attachmentData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 52,
            fileType: this.fileType,
            base64String: this.filesResult,
          });
        };
      } else {
        this.alertService.error(
          "File size is large, Please upload less than 2 MB"
        );
        this.physicalVerifyName = "";
      }
    } else {
      this.alertService.error("Please upload JPG, JPEG, PNG and PDF only");
    }
  }

  LaserCutUpload(event) {
    const file = event.target.files[0];
    if (
      file.type === "application/pdf" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/jpeg"
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.laserCutName = file.name;
      let checkType = file.type;
      let getFileType = checkType.split("/");
      if (getFileType[1] == "pdf") {
        this.fileType = 2;
      } else {
        this.fileType = 1;
      }
      if (acceptsize < 2048) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          // this.filesResult = event.target.result;
          this.filesResult = event.target.result.split(",")[1];
          this.form.controls["laserCutImage"].setValue(this.filesResult);
          // this.form.controls['ins_filename'].setValue(file.name);
          this.attachmentData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 86,
            fileType: this.fileType,
            base64String: this.filesResult,
          });
        };
      } else {
        this.alertService.error(
          "File size is large, Please upload less than 2 MB"
        );
        this.laserCutName = "";
      }
    } else {
      this.alertService.error("Please upload JPG, JPEG, PNG and PDF only");
    }
  }
}
